import { apiRequest } from 'lib/API';

export const trackEvent = (eventName, item = {}) => {
  return new Promise((resolve) => {
    if (typeof item != 'object') {
      item = { value: item };
    }
    apiRequest('post', '/events', {
      data: {
        action: 'event',
        name: eventName,
        item: item,
        location: window.location.hash,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch(() => {
        resolve();
        console.log('Error tracking event'); //eslint-disable-line
      });
  });
};
